<template>
  <layout-side-menu-content>

    <form-component />
    <button-update v-if="isEdit" />
    <button-edit v-else />
  </layout-side-menu-content>
</template>

<script>
import LayoutSideMenuContent from '@/lib/Layout/SideMenuContent'
import FormComponent from './FormComponent/index'
import ButtonUpdate from './ButtonUpdate'
import ButtonEdit from './ButtonEdit'

export default {
  components: {
    LayoutSideMenuContent,
    FormComponent,
    ButtonUpdate,
    ButtonEdit
  },

  data () {
    return {
      modelName: 'seatingStatus',
    }
  },

  computed: {
    isEdit () {
      return this.$store.getters[`${this.modelName}/getAttr`]('isEdit')
    }
  }
}
</script>
